export default __webpack_public_path__ + "static/media/hand.9304d0cc.svg";